import { render, staticRenderFns } from "./FilterByClinics.vue?vue&type=template&id=15ca5bb7&scoped=true"
import script from "./FilterByClinics.vue?vue&type=script&lang=js"
export * from "./FilterByClinics.vue?vue&type=script&lang=js"
import style0 from "./FilterByClinics.vue?vue&type=style&index=0&id=15ca5bb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca5bb7",
  null
  
)

export default component.exports